import React from 'react';
import AppLayouts from './AppLayouts';
import Routes from '../../app/routes';
import { useSelector } from 'react-redux';

import { LicenseInfo } from '@mui/x-license-pro';

const AppLayout = () => {
  LicenseInfo.setLicenseKey(
    '4e795a067afb01a07300491f6e247538Tz0xMTkzODgsRT0xNzkwMDIxNTk2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
  );

  const horizontalNavPosition = useSelector(
    ({ settings }) => settings.horizontalNavPosition
  );
  const navigationStyle = useSelector(
    ({ settings }) => settings.navigationStyle
  );
  const onGetLayout = (layout) => {
    switch (layout) {
      case 'inside_the_header':
        return 'InsideHeaderNav';

      case 'above_the_header':
        return 'AboveHeaderNav';

      case 'below_the_header':
        return 'BelowHeaderNav';
      default:
        return 'Vertical';
    }
  };

  const Layout =
    AppLayouts[
      navigationStyle === 'vertical_navigation'
        ? 'Vertical'
        : onGetLayout(horizontalNavPosition)
    ];
  return (
    <Layout>
      <Routes />
    </Layout>
  );
};

export default AppLayout;
